import { ApiResponse } from 'apisauce';
import { IPaginationSnapshot } from 'src/models/pagination/Pagination';

import { IInfraImage, IInfraImageSnapshot } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteInfraImageResult,
  TGetInfraImageResult,
  TGetInfraImagesResult,
  TSaveInfraImageResult,
} from './InfraImageTypes';

export class InfraImageApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async gets(generate?: 'generate'): Promise<TGetInfraImagesResult> {
    try {
      const url = '/infraImage';
      const params = generate ? { useYn: 'Y' } : {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const infraImages: IInfraImage[] = response.data.data;
      const pagination: IPaginationSnapshot = response.data.pagination;
      const responseInfo = response.data;
      return { kind: 'ok', infraImages, pagination, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async get(imageSid: number): Promise<TGetInfraImageResult> {
    try {
      const url = `/infraImage/${imageSid}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const infraImage: IInfraImage = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', infraImage, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async save(newInfraImage: IInfraImageSnapshot, file?: File): Promise<TSaveInfraImageResult> {
    try {
      const hasSid = !!newInfraImage.imageSid;
      const url = hasSid ? `/infraImage/${newInfraImage.imageSid}` : '/infraImage';
      const formData = new FormData();
      file && formData.append('file', file);

      for (const key in newInfraImage) {
        const value = (newInfraImage as any)[key];
        // post일 경우 imageSid, imagePath는 제외
        if (!hasSid && (key === 'imageSid' || key === 'imagePath')) {
          continue;
        }
        if (value !== undefined && value !== null) {
          formData.append(key, String(value));
        }
      }

      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
      };
      const response: ApiResponse<any> = await method(url, formData, config);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const infraImage: IInfraImage = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', infraImage, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async delete(imageSid: number): Promise<TDeleteInfraImageResult> {
    try {
      const url = `/infraImage/${imageSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.delete(url);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
